<div class="status"
  [ngClass]="getClass()">
  {{ title | status }}
</div>